define([
  "marionette",
  "backbone",
  "jquery",
  "underscore",
  "messaging/messenger",
  "moment",
  "./taskWizardLocaleStepsPageView",
  "modules/tasks/taskWizardModal/taskSteps/taskStepsModule",
], function (
  Marionnete,
  Backbone,
  $,
  _,
  Messenger,
  moment,
  TaskWizardLocaleStepsPageView,
  TaskStepsModule,
) {
  "use strict";

  var TaskWizardLocaleStepsPageController = Marionnete.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "taskWizardLocaleStepsPage";
    },
    show: function (task, languageIndex) {
      var languageIds = task.get("languageIds");
      var languages = Messenger.reqres.request("kb:languages");
      this.task = task;
      this.languages = languages;
      this.languageIndex = languageIndex;
      this.languageId = languageIds[languageIndex];
      var languageName = languages.get(this.languageId).get("name");
      this.model = new Backbone.Model({
        description: task.get("description"),
        languages: this._filterLanguages(task, this.languageId, languages),
        languageId: this.languageId,
        languageName: languageName,
        name: task.get("name"),
        title: $.t("task.wizard.localeStepsPageTitle", {
          step_number: languageIndex + 1,
        }),
      });
      this.view = new TaskWizardLocaleStepsPageView.localeStepsPageView({ model: this.model });
      this.taskSteps = this.addSubModule(
        new TaskStepsModule({
          languageId: this.languageId,
          region: this.view.taskSteps,
        }),
      );
      this.view.on("change:locale", this._onChangeLocale, this);
      this.view.on("show", this._onShow, this);
      this.showRegion(this.view);
    },
    commitData: function () {
      this.view.clearErrors();
      this.task.set({
        description: this.view.getTaskDescription(),
        name: this.view.getTaskName(),
      });
      var taskStepsValid = this.taskSteps.commitData();
      if (!this.task.get("name")) {
        this.view.nameError($.t("commonMessages.emptyMessage"));
        return false;
      }
      if (!this.task.get("description")) {
        this.view.descriptionError($.t("commonMessages.emptyMessage"));
        return false;
      }
      if (!taskStepsValid) {
        return false;
      }
      var languageId = this.languageId;
      var languageStep = this.task.steps().findWhere({ languageId: languageId });
      if (!languageStep) {
        var languageName = this.model.get("languageName");
        this.view.localesError($.t("task.wizard.emptyLocaleSteps", { locale_name: languageName }));
        return false;
      }
      return true;
    },
    _filterLanguages: function (task, languageId, languages) {
      // To help the user select only a language that has not already been added to the task, filter out
      // all languages that are in the task.languageIds (except the languageId that is active for this page)
      var languageIds = task.get("languageIds");
      return languages.filter(function (language) {
        return language.id == languageId || !_.contains(languageIds, language.id);
      });
    },
    _onChangeLocale: function (options) {
      var newLanguageId = +options.value;
      this.taskSteps.changeLanguage(newLanguageId);
      this.languageId = newLanguageId;
      this.task.get("languageIds")[this.languageIndex] = newLanguageId;
      this.model.set({
        languageId: newLanguageId,
        languageName: this.languages.get(newLanguageId).get("name"),
      });
    },
    _onShow: function () {
      this.taskSteps.show(this.task);
    },
  });

  return TaskWizardLocaleStepsPageController;
});
